<template>
  <div>
    <!-- Refund -->
    <span v-if="payment.price < 0">
      <span class="text-success">
        Remboursé le {{ formatDate(payment.capturedAt) }}
      </span>
      <span
        v-if="hasRefundOrderInvoice"
        v-tooltip="payment.refundOrder.invoice.serial"
        class="fa fa-info-circle"
      ></span>
    </span>
    <!-- Refund -->

    <!-- Captured -->
    <span v-else-if="payment.captured" class="text-success"
      >Payé le {{ formatDate(payment.capturedAt) }}</span
    >
    <!-- Captured -->

    <!-- Pending -->
    <span v-else class="small">En attente</span>
    <!-- Pending -->

    <br />

    <strong class="small strong" v-if="payment.nbSessions"
      >{{ payment.nbSessions }} séance{{ payment.nbSessions > 1 ? "s" : "" }}
    </strong>

    <br />

    <a
      v-if="hasInvoice"
      class="link"
      @click="downloadSecuredFile(`uploads/invoice/${payment.invoice.pdf}.pdf`)"
      v-on:click.stop
    >
      {{ payment.invoice.serial }}
    </a>
  </div>
</template>

<script>
import DownloadFile from "@/mixin/DownloadFile";

export default {
  props: {
    payment: {
      type: Object,
      required: true,
    },
  },

  mixins: [DownloadFile],

  computed: {
    hasRefundOrderInvoice() {
      return !!this.payment.refundOrder?.invoice?.serial;
    },

    hasInvoice() {
      return !!this.payment.invoice?.pdf;
    },
  },
};
</script>
